import * as d3 from 'd3';

export const guid = function () {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return 'ID' + s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4();
};


//把searchOption变成 elasticsearch的query
export const mergeSearchOption = function (searchOption) {
  if (searchOption.text.length < 1 && searchOption.time.length < 1) {
    return;
  }
  const [and, not, or] = [[], [], []];
  searchOption.text.forEach(row => {
    let key = row.searchkey;
    if (row.logic === 'and') {
      and.push(key);
    } else if (row.logic === 'not') {
      not.push(key);
    } else if (row.logic === 'or') {
      or.push(key);
    }
  });

  const [time_and, time_not, time_or] = [[], [], []];
  searchOption.time.forEach(row => {
    let { from, to } = row;
    if (!from && !to) {
      return;
    }

    const val = {
      from: from,
      to: to
    };

    if (row.logic === 'and') {
      time_and.push(val);
    } else if (row.logic === 'not') {
      time_not.push(val);
    } else if (row.logic === 'or') {
      time_or.push(val);
    }
  });

  return {
    text: {
      and: and,
      not: not,
      or: or
    },
    time: {
      and: time_and,
      not: time_not,
      or: time_or
    }
  };

}



export const cleanSearchFieldData = function (_searchFormData) {
  if (!_searchFormData) {
    return;
  }
  let text = [];
  const _addSearchKey = function (obj, w) {
    if (!w) {
      return;
    }
    const clone = JSON.parse(JSON.stringify(obj));
    clone.searchkey = w;
    text.push(clone);
  }
  _searchFormData.text.forEach(t => {
    let key = t.searchkey;
    if (key === undefined || key === '' || key === null) {
      return;
    }
    key = key.trim();
    if (key === '') {
      return;
    }

    //aa "bbb bb" cc dd "eee ff" ggg
    const regex = /"[^"]+"/;
    let matchRes = key.match(regex);
    //search key split
    let max = 100;
    //防止死循环
    while (matchRes && max) {
      max--;
      const idx = matchRes.index;
      if (idx > 0) {
        //前面正常的字符 
        key.substring(0, idx).trim().split(' ').forEach(s => {
          _addSearchKey(t, s);
        })
      }
      _addSearchKey(t, matchRes[0]);
      key = key.substring(idx + matchRes[0].length).trim();
      matchRes = key.match(regex);
    }
    if (!key) {
      return;
    }
    key.split(" ").forEach(w => {
      _addSearchKey(t, w);
    });
  });


  const time = [];
  _searchFormData.time.forEach(row => {
    let { from, to } = row;
    if (!from && !to) {
      return;
    }
    time.push(row);
  });
  if (text.length + time.length < 1) {
    return;
  }

  return {
    text: text.length > 0 ? text : null,
    time: time.length > 0 ? time : null
  };
};

//attribute mit _ Anfang nicht kopieren
export const deepFilterCopy = function (obj) {
  let tempObj = Array.isArray(obj) ? [] : {};
  for (let key in obj) {
    if (key.indexOf('_') == 0) {
      continue;
    }
    const o = obj[key];
    tempObj[key] = (typeof o === 'object' || typeof o === 'function') && o !== null ? deepFilterCopy(o) : o;
  }
  return tempObj;
};


export const deepCopySlide = function deepCopy(obj) {
  let tempObj = Array.isArray(obj) ? [] : {};
  for (let key in obj) {
    const o = obj[key];
    if (key.indexOf('__') == 0) {
      tempObj[key] = null;
    } else if (key.indexOf('_') == 0) {
      tempObj[key] = o;
    } else {
      tempObj[key] = (typeof o === 'object' || typeof o === 'function') && o !== null ? deepCopy(o) : o;
    }
  }
  return tempObj;
};

export const cloneToolbarItemData = function (data) {
  const clone = {};
  Object.keys(data).forEach(key => {
    if (key.indexOf('__') == 0) {
      clone[key] = null;
    } else if (key.indexOf('_') == 0) {
      clone[key] = data[key];
    } else {
      clone[key] = JSON.parse(JSON.stringify(data[key]));
    }
  });
  return clone;
};

export const fullTimeFormat = function (date) {
  return d3.timeFormat('%Y-%m-%d %H:%M:%S')(date);
};

export const getDocSubtitle = function (doc) {
  let out = [];

  if (doc.i && !doc.idDocument) {
    if (doc.x && doc.x[0]) {
      out.push(doc.x[0].n);
    }
    if (doc.dd) {
      out.push(doc.dd);
    }

    if (doc.j === 'di') {
      out.push('Tagebuch');
    } else {
      out.push('Brief');
    }
  } else {
    if (doc.schreibort && doc.schreibort[0]) {
      out.push(doc.schreibort[0].name);
    }
    if (doc.datierung && doc.datierung[0]) {
      out.push(doc.datierung[0].datum);
    }

    if (doc.docType === 'di') {
      out.push('Tagebuch');
    } else {
      out.push('Brief');
    }
  }
  return out.join(', ');
};

export const formatDeDate = function (date) {
  var monthNames = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

  var day = date.getDate();
  var monthIndex = date.getMonth();
  var year = date.getFullYear();

  return day + '. ' + monthNames[monthIndex] + ' ' + year;
};

export const mergeIntervals = function (intervals) {
  // test if there are at least 2 intervals
  if (intervals.length <= 1) return intervals;

  var stack = [];
  var top = null;

  // sort the intervals based on their start values
  intervals = intervals.sort();

  // push the 1st interval into the stack
  stack.push(intervals[0]);

  // start from the next interval and merge if needed
  for (var i = 1; i < intervals.length; i++) {
    // get the top element
    top = stack[stack.length - 1];

    // if the current interval doesn't overlap with the
    // stack top element, push it to the stack
    if (top[1] < intervals[i][0]) {
      stack.push(intervals[i]);
    }
    // otherwise update the end value of the top element
    // if end of current interval is higher
    else if (top[1] < intervals[i][1]) {
      top[1] = intervals[i][1];
      stack.pop();
      stack.push(top);
    }
  }

  return stack;
};

export const XSLTransform = function (xmlStr) {
  return new Promise((resolve, reject) => {
    try {
      xmlStr = xmlStr.replace('<TEI>', '<TEI  xmlns="http://www.tei-c.org/ns/1.0">');
      xmlStr = xmlStr.replace('& ', '&amp; ');
      // xmlStr = xmlStr.replace(/@@@/g, '&amp;');
      // xmlStr = xmlStr.replace(/&/g, '&amp;');
      let xmlDoc = $.parseXML(xmlStr);
      let xsl = $.parseXML(transformXSL);

      const node = document.createElement('div');
      if (window.ActiveXObject || 'ActiveXObject' in window) {
        let xslt = new ActiveXObject('Msxml2.XSLTemplate');
        let xslDoc = new ActiveXObject('Msxml2.FreeThreadedDOMDocument');
        xslDoc.loadXML(xslStr);
        xslt.stylesheet = xslDoc;

        let xslProc = xslt.createProcessor();
        xslProc.input = xmlDoc;
        xslProc.transform();
        node.innerHTML = xslProc.output;
      } else if (document.implementation && document.implementation.createDocument) {
        let xsltProcessor = new XSLTProcessor();
        xsltProcessor.importStylesheet(xsl);
        let resultDocument = xsltProcessor.transformToFragment(xmlDoc, document);
        node.appendChild(resultDocument);
      }
      resolve(node.firstChild);
    } catch (err) {
      reject(err);
    }
  });
};

export const getObjectNamesFromHtml = function (elem) {
  const set = new Set();
  const clone = elem.cloneNode(true);
  const hiddenNodes = clone.querySelectorAll('.ev-xsl__comment-container');
  for (const n of hiddenNodes) {
    n.innerHTML = '';
  }
  const nameNodes = clone.querySelectorAll("[class^='ev-xsl__name']");
  for (const el of nameNodes) {
    set.add(el.getAttribute('data-objectName'));
  }
  return [...set];
}

export const updateRenderingHtml = function (elem, renderingSelection) {
  const nameNodes = elem.querySelectorAll(
    "[class^='ev-xsl__name']"
  );
  nameNodes.forEach(n => {
    let c = false;
    renderingSelection.forEach(name => {
      const className = "ev-xsl__name--" + name;
      if (n.classList.contains(className)) {
        c = true;
      }
    });
    if (c) {
      n.classList.remove("ev-normal-text-bg");
    } else {
      n.classList.add("ev-normal-text-bg");
    }
  });
}

export const mergeInterval = function (ranges) {
  if (ranges.length < 1) return ranges;
  //对 ranges 排序
  // ranges = ranges.sort(function (a, b) {
  //   return a[0] - b[0];
  // });
  //解释：a,b表示数组中的任意两个元素，若return > 0 b前a后；reutrn < 0 a前b后；a=b时存在浏览器兼容
  // 简化一下：a-b输出从小到大排序，b-a输出从大到小排序。
  var newRanges = [];
  var i1 = ranges[0];
  for (var i = 0, len = ranges.length; i < len; i++) {
    var i2;
    if (i === len - 1) {
      //如果i到最后，增加一个虚拟最大的区间
      i2 = [Number.MAX_VALUE, Number.MAX_VALUE];
    } else {
      i2 = ranges[i + 1];
    }
    //合并区间
    if (i2[0] >= i1[0] && i2[0] <= i1[1]) {
      i1[1] = Math.max(i1[1], i2[1]);
    } else {
      //没有交集，直接添加
      newRanges.push(i1);
      i1 = i2; //i1更迭
    }
  }
  return newRanges;
};

export const deLocalTimeFormat = d3.timeFormatDefaultLocale({
  decimal: ',',
  thousands: '.',
  grouping: [3],
  currency: ['€', ''],
  dateTime: '%a %b %e %X %Y',
  date: '%d.%m.%Y',
  time: '%H:%M:%S',
  periods: ['AM', 'PM'],
  days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
  shortDays: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
  shortMonths: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
});

export const timelineTickFormat = function (date) {
  if (date.getMinutes()) {
    return;
  } else if (date.getHours()) {
    return;
  } else if (date.getDay() && date.getDate() != 1) {
    return deLocalTimeFormat.format('%d.%b')(date);
  } else if (date.getDate() != 1) {
    return deLocalTimeFormat.format('%d.%b')(date);
  } else if (date.getMonth()) {
    return deLocalTimeFormat.format('%b')(date);
  } else {
    return deLocalTimeFormat.format('%Y')(date);
  }
};

//date to string
export const deDateToString = function (d) {
  let format = d3.timeFormat('%d.%m.%Y');
  return format(d);
};

export const dateToIso = function (d) {
  let format = d3.timeFormat('%Y-%m-%d');
  return format(d);
};

// string to date
export const deString2Date = function (s) {
  return d3.timeParse('%d.%m.%Y')(s);
};
export const isoToDate = function (d) {
  return d3.timeParse('%Y-%m-%d')(d);
};

export const roughSizeOfObject = function (object) {
  var objectList = [];
  var stack = [object];
  var bytes = 0;

  while (stack.length) {
    var value = stack.pop();

    if (typeof value === 'boolean') {
      bytes += 4;
    }
    else if (typeof value === 'string') {
      bytes += value.length * 2;
    }
    else if (typeof value === 'number') {
      bytes += 8;
    }
    else if
      (
      typeof value === 'object'
      && objectList.indexOf(value) === -1
    ) {
      objectList.push(value);

      for (var i in value) {
        stack.push(value[i]);
      }
    }
  }
  return bytes / 1000 + 'k';
}


// WEBPACK FOOTER //
// ./src/utils/utils.js